import {Moment} from "moment";

export class HqPackingListParentInfo {
    id?: string
    code?: string
    inStateDesc?: string
    outStateDesc?: string
    sellerName?: string
    purchaserName?: string
    logisticsClerkName?: string
    storageLayerNames?: string
    companyCode?: string
    customerCode?: string
    customerName?: string
    remark?: string
    createdAt?: string
    estimatedSailingSchedule?: string
    reserved?: boolean
    estimatedInStorageDateEnd?: Moment
    estimatedInStorageDateStart?: Moment
    estimatedNextDeliveryDate?: Moment
    productVolume?: number
    createName?: string
    state?: any
    canUpload?: boolean
}